import gql from "graphql-tag";

export default gql`
  query article($siteId: [QueryArgument], $id: [QueryArgument]) {
    article: entry(id: $id, siteId: $siteId) {
      ... on article_default_Entry {
        slug
        bodyCopy {
          ... on bodyCopy_collapsableBlock_BlockType {
            id
            slug: childSlug
          }
        }
      }
    }
  }
`;
